module.exports = __webpack_public_path__ + "img/scdf_logo.003f6268.png";